var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"program"},[_c('program-head',{attrs:{"val":_vm.head_content}}),_c('carousel2',{staticClass:"carousel",attrs:{"val":_vm.img_content}}),_c('sub-bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }